import IntroImage from "@/assets/images/about/intro-image1.webp";
import { Zap, Users, Target, Heart } from "lucide-react";

export default function IntroSection() {
	return (
		<section className="relative pt-16 pb-12 md:pt-24 md:pb-16 overflow-hidden">
			{/* Animated background elements */}
			<div className="absolute inset-0 opacity-30">
				<div className="absolute top-20 right-20 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
				<div className="absolute bottom-20 left-20 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
			</div>

			<div className="container relative z-10">
				{/* Modern header with accent */}
				<div className="text-center mb-16 md:mb-20">
					<div className="inline-block mb-4">
						<span className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm text-xs md:text-sm font-semibold text-gray-300 tracking-wider uppercase">
							About Us
						</span>
					</div>
					<h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
						Discover the Future of{" "}
						<span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
							Innovation
						</span>
					</h2>
					<p className="text-gray-300 md:text-lg max-w-2xl mx-auto">
						Transforming businesses through cutting-edge technology and tailored solutions
					</p>
				</div>

				<div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
					{/* Image with modern styling */}
					<div className="relative group">
						<div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
						<div className="relative rounded-2xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-sm">
							<img
								src={IntroImage}
								alt="Team collaboration"
								className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500"
							/>
						</div>
						{/* Decorative corner elements */}
						<div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-blue-400/50 rounded-tl-2xl"></div>
						<div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-purple-400/50 rounded-br-2xl"></div>
					</div>

					{/* Content with modern cards */}
					<div className="space-y-6">
						<div className="group p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-blue-400/30 transition-all duration-300 hover:bg-white/10">
							<div className="flex items-start gap-4">
								<div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center group-hover:shadow-lg group-hover:shadow-purple-500/30 transition-shadow duration-300">
									<Zap className="w-6 h-6 text-white" />
								</div>
								<p className="text-gray-300 leading-relaxed">
									We are a trusted IT provider using technology to drive innovation and business success.
								</p>
							</div>
						</div>

						<div className="group p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-purple-400/30 transition-all duration-300 hover:bg-white/10">
							<div className="flex items-start gap-4">
								<div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center group-hover:shadow-lg group-hover:shadow-purple-500/30 transition-shadow duration-300">
									<Users className="w-6 h-6 text-white" />
								</div>
								<p className="text-gray-300 leading-relaxed">
									Our team delivers tailored solutions that help your business grow and succeed.
								</p>
							</div>
						</div>

						<div className="group p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-blue-400/30 transition-all duration-300 hover:bg-white/10">
							<div className="flex items-start gap-4">
								<div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center group-hover:shadow-lg group-hover:shadow-purple-500/30 transition-shadow duration-300">
									<Target className="w-6 h-6 text-white" />
								</div>
								<p className="text-gray-300 leading-relaxed">
									We provide the tools and guidance you need to achieve your goals efficiently.
								</p>
							</div>
						</div>

						<div className="group p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-purple-400/30 transition-all duration-300 hover:bg-white/10">
							<div className="flex items-start gap-4">
								<div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center group-hover:shadow-lg group-hover:shadow-purple-500/30 transition-shadow duration-300">
									<Heart className="w-6 h-6 text-white" />
								</div>
								<p className="text-gray-300 leading-relaxed">
									We build lasting relationships with clients based on trust and collaboration.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}